// import React, { useCallback, useState } from "react";
// import { useDropzone } from "react-dropzone";

// const UploadSurface = () => {
//     const [files, setFiles] = useState([]);

//     const onDrop = useCallback((acceptedFiles) => {
//         setFiles((prev) => [...prev, ...acceptedFiles]);
//     }, []);

//     const removeFile = (fileName) => {
//         setFiles((prev) => prev.filter((file) => file.name !== fileName));
//     };

//     const { getRootProps, getInputProps, isDragActive } = useDropzone({
//         onDrop,
//         accept: { "text/csv": [".csv"] },
//     });

//     return (
//         <div className="uploaded-surface-section">
//             <div className="row">
//                 {/* Upload Box */}
//                 <div className="col-md-7">
//                     <div className="uploaded-area-box">
//                         <h6 className="inner-title">Upload files containing surface area measurements</h6>
//                         <div
//                             {...getRootProps()}
//                             className="dropzone-box">
//                             <input {...getInputProps()} />
//                             <div className="dropzone-content">
//                                 <span className="icon"><i className="icon-icon-31 d-flex"></i></span>
//                                 <p>
//                                     Drag and drop files here, or click to browse
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Uploaded Files */}
//                 <div className="col-md-5">
//                     <div className="uploaded-surface-box">
//                         <h6 className="inner-title">Uploaded Surface Data</h6>
//                         <div className="uploaded-surface-list">
//                             {files.map((file) => (
//                                 <div
//                                     key={file.name}
//                                     className="uploaded-surface-item"
//                                 >
//                                     <div className="title-icon d-flex align-items-center">
//                                         <div className="icon">
//                                             <i className="icon-icon-32 d-flex"></i>
//                                         </div>
//                                         <p className="file-title mb-0">{file.name}</p>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         onClick={() => removeFile(file.name)}
//                                         className="remove-btn"
//                                     >
//                                         <i className="icon-icon-14"></i>
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default UploadSurface;


import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

const UploadSurface = ({ setFieldValue, setFieldTouched, setFieldError, file }) => {
  // Use Formik's file field value directly
  const onDrop = useCallback(
    (acceptedFiles) => {
      // Assuming single file upload as per validation schema
      const newFile = acceptedFiles[0] || null;
      setFieldValue("file", newFile); // Update Formik's file field
      if (newFile) {
        if (typeof setFieldTouched === 'function') setFieldTouched('file', true, false);
        if (typeof setFieldError === 'function') setFieldError('file', undefined);
      }
    },
    [setFieldValue, setFieldTouched, setFieldError]
  );

  const removeFile = () => {
    setFieldValue("file", null); // Clear Formik's file field
    if (typeof setFieldTouched === 'function') setFieldTouched('file', true, false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"] },
    multiple: false, // Enforce single file upload as per schema
  });

  return (
    <div className="uploaded-surface-section">
      <div className="row">
        {/* Upload Box */}
        <div className="col-md-7">
          <div className="uploaded-area-box">
            <h6 className="inner-title">Upload files containing surface area measurements</h6>
            <div {...getRootProps()} className="dropzone-box">
              <input {...getInputProps()} />
              <div className="dropzone-content">
                <span className="icon">
                  <i className="icon-icon-31 d-flex"></i>
                </span>
                <p>Drag and drop a .xlsx file here, or click to browse</p>
              </div>
            </div>
          </div>
        </div>

        {/* Uploaded Files */}
        <div className="col-md-5">
          <div className="uploaded-surface-box">
            <h6 className="inner-title">Uploaded Surface Data</h6>
            <div className="uploaded-surface-list">
              {file && (
                <div className="uploaded-surface-item">
                  <div className="title-icon d-flex align-items-center">
                    <div className="icon">
                      <i className="icon-icon-32 d-flex"></i>
                    </div>
                    <p className="file-title mb-0">{file.name}</p>
                  </div>
                  <button type="button" onClick={removeFile} className="remove-btn">
                    <i className="icon-icon-14"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadSurface;